module.exports = __webpack_public_path__ + "static/media/chess-king-alt.16f35fb5.svg";